import styled from 'styled-components';

export const MarkerContainer = styled.div`
  margin-left: 8px;
`;
